<template>
    <div class="top-nav-container" v-if="isShow">
        <div class="menu-view" v-if="!isUnion">
            <div :key="index" class="menu-item" v-for="(item, index) in menu" @click="menuHandle(item)">
                <router-link :to="item.Url">
                    <el-image class="menu-image" fit="fill" :src="downloadUrl + item.Vector" :onerror="defaultImg" />
                    <p>{{ item.Name }}</p>
                </router-link>
            </div>
        </div>
        <div class="menu-view" v-else>
            <div :key="index" class="menu-item" v-for="(item, index) in unions" @click="gotoUnion(item, index)">
                <el-image class="menu-image" fit="fill" :src="downloadUrl + item.LogoUrl" :onerror="defaultImg" />
                <div class="loading" v-if="item.loading">
                    <el-progress :width="65" class="progress" type="circle" :percentage="item.percentage" />
                </div>
                <p>
                    {{ item.Abbr }}
                    <img v-if="item.IsAdmin" class="icon" src="@/assets/images/admin.png" />
                </p>
            </div>
        </div>
        <div class="arrow-view">
            <i class="el-icon-arrow-down"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            menu: {},
            unions: {},
            isShow: false, // 是否展示
            isUnion: false, // 当前展示的是否是联盟
            permission: {}
        };
    },
    watch: {
        // 监控路由变化
        $route(to, from) {
            // path 带有 entpUnion 字段的表示为联盟页面，需要切换头部内容
            this.setNavList(to.path);
        }
    },
    mounted() {
        //登录进来时还没有拿到权限的
        this.$util.getTreeForTop().then(() => {
            this.permission = this.$util.getPermission('Union');
            this.setNavList(this.$route.path);
        });
        this.menuHandle();
    },
    methods: {
        // 跳转页面：path 带有 entpUnion 字段的表示为联盟页面
        setNavList(path) {
            if (path === '/') {
                this.isShow = false;
                return;
            } else if (path.indexOf('entpUnion') > -1) {
                this.getHomeModules();
            } else {
                this.getUnionDatas(false);
            }
        },
        // 切换标题
        menuHandle(row) {
            if (row && row.Name) {
                document.title = row.Name;
            } else {
                document.title = '车回佳企业客户端管理系统';
            }
        },
        // 获取首页模块
        getHomeModules() {
            this.$util.getHomeModules().then(data => {
                this.menu = data;
                if (!data || (Array.isArray(data) && data.length === 0)) {
                    this.isShow = false;
                } else {
                    this.isUnion = false;
                    this.isShow = true;
                }
            });
        },
        // 获取联盟模块
        getUnionDatas(isClear) {
            this.$util.getUnionDatas(isClear).then(data => {
                this.unions = data.map(m => {
                    return {
                        ...m,
                        loading: false,
                        percentage: 0
                    };
                });
                if (!data || (Array.isArray(data) && data.length === 0)) {
                    this.isShow = false;
                } else {
                    if (this.permission.addUnion || this.permission.joinUnion) {
                        this.isUnion = true;
                        this.isShow = true;
                    } else {
                        this.isShow = false;
                    }
                }
            });
        },
        // 联盟初始化
        gotoUnion(row, index) {
            let that = this;
            let unionId = row.UnionId;
            this.menuHandle(row);
            if (that.unions[index].loading) return;
            that.unions[index].loading = true;
            if (unionId) {
                //现要判断联盟是否已经被禁用或者成员是否已经被踢出联盟
                that.$util
                    .axiosGet({
                        url: '/api/EntpUnions/CheckUnionState',
                        data: {
                            UnionId: unionId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        that.unions[index].percentage = 50;
                        let currentUnion = that.$util.getLocalStorage('currentUnion');
                        if (!currentUnion) {
                            that.$util.setLocalStorage('currentUnion', unionId);
                            that.$store.commit('updateReflashUnion', true);
                        } else {
                            if (currentUnion !== unionId) {
                                that.$util.setLocalStorage('currentUnion', unionId);
                                that.$store.commit('updateReflashUnion', true);
                            }
                        }
                        that.$util.getUnionTree().then(() => {
                            that.unions[index].percentage = 100;
                            setTimeout(() => {
                                that.$router.push('/entpUnion/unionManage/unionInfoes');
                                that.unions[index].loading = false;
                            }, 500);
                        });
                    })
                    .catch(() => {
                        that.getUnionDatas(true);
                    });
            } else that.$util.warningMsg('联盟信息异常，请刷新后重试');
        }
    }
};
</script>

<style lang="less" scoped>
.top-nav-container {
    position: fixed;
    z-index: 99;
    top: -131px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    cursor: pointer;
    transition: top 0.3s;
}
.top-nav-container:hover {
    top: 0;
}
.arrow-view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 120px;
    height: 20px;
    font-size: 28px;
    background-color: rgba(255, 255, 255, 0.7);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.menu-view {
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    background-color: rgba(255, 255, 255, 0.7);
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    max-width: 920px;
    height: 130px;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    .menu-item {
        position: relative;
        text-align: center;
        color: #252a2f;
        padding: 5px 10px;
        border-radius: 12px;
        .menu-image,
        .loading {
            width: 80px;
            height: 80px;
            overflow: hidden;
            border-radius: 16px;
            margin-bottom: 5px;
        }
        .loading {
            position: absolute;
            z-index: 1;
            top: 5px;
            left: 50%;
            transform: translateX(-50%);
            background-color: rgba(255, 255, 255, 0.7);
            .progress {
                top: 7.5px;
            }
        }
        a {
            color: #252a2f;
        }
        .icon {
            width: 15px;
            height: 15px;
            margin-top: -1px;
        }
    }
}
.menu-view::-webkit-scrollbar {
    display: none;
}
</style>
